import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-youth',
  templateUrl: './youth.component.html',
  styleUrls: ['./youth.component.scss']
})
export class YouthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
